export const LOCAL_STORAGE = {
  QUERY_PARAMS: "queryParams",
  SUBSCRIPTIONS: "rentspreeSubscriptions",
  USER_TOKEN_TEMP: "rentspreeUserTokenTemp",
  TEMP_USER: "rentspreeTempUser"
}
